import { breakpoints } from './breakpoints';

const theme = {
  font: 'Montserrat, sans-serif',
  breakpoints,
};

export default theme;
